import axios from "axios";
import Element from "element-ui"

// axios.defaults.baseURL = "http://localhost:8865"
// axios.defaults.baseURL = "http://localhost:9993"
axios.defaults.baseURL = "https://biaodan.wjhfz.com/api"
// axios.defaults.baseURL = "http://sj.dayoutz.cn:9994/api"


const request = axios.create({
	timeout: 5000,
	headers: {
		'Content-Type': "application/json; charset=utf-8"
	}
})

request.interceptors.request.use(config => {
	config.headers['Authorization'] = localStorage.getItem("token")
	return config
})

request.interceptors.response.use(
	response => {

		let res = response.data

		if (res.code === 200) {
			return response
		} else {
			Element.Message.error(!res.msg ? '系统异常' : res.msg)
			return Promise.reject(response.data.msg)
		}
	},
	error => {

		if (error.response.data) {
			error.massage = error.response.data.msg
		}

		Element.Message.error(error.massage, {duration: 3000})
		return Promise.reject(error)
	}
)

export default request